import { apiConfig, PAYMENT_ENDPOINTS } from '@/config/api';
import { getPaymentReturnUrl } from '@/config/lk';
import { httpClient } from '@/lib/http-client';
import type {
  CreatePaymentRequest,
  CustomerPaymentOptions,
  MethodsList,
  Payment,
  PaymentMethod,
  PaymentResult,
} from '@/types/payment';

export class PaymentsApi {
  static getPaymentOptions(): Promise<CustomerPaymentOptions> {
    return httpClient.get<CustomerPaymentOptions>(PAYMENT_ENDPOINTS.PAYMENT_OPTIONS);
  }

  static createPayment(data: CreatePaymentRequest): Promise<PaymentResult> {
    return httpClient.post<PaymentResult, CreatePaymentRequest>(
      PAYMENT_ENDPOINTS.PAYMENTS,
      data,
    );
  }

  static getPayment(paymentId: string): Promise<Payment> {
    return httpClient.get<Payment>(PAYMENT_ENDPOINTS.PAYMENT_BY_ID(paymentId));
  }

  static getVaultMethods(): Promise<MethodsList> {
    return httpClient.get<MethodsList>(PAYMENT_ENDPOINTS.VAULT);
  }

  static getVaultMethod(methodId: string): Promise<PaymentMethod> {
    return httpClient.get<PaymentMethod>(PAYMENT_ENDPOINTS.VAULT_METHOD_BY_ID(methodId));
  }

  static deleteVaultMethod(methodId: string): Promise<void> {
    return httpClient.delete<void>(PAYMENT_ENDPOINTS.VAULT_METHOD_BY_ID(methodId));
  }
}

export function buildPaymentReturnUrl(): string {
  return getPaymentReturnUrl();
}

function getPayBaseUrl(): string {
  return apiConfig.baseUrl.replace('://api.', '://pay.');
}

export function buildSberPayUrl(paymentId: string, orderId: string): string {
  const url = new URL(`${getPayBaseUrl()}/sber`);
  url.searchParams.set('paymentId', paymentId);
  url.searchParams.set('mdOrder', orderId);
  url.searchParams.set('lang', 'ru');
  return url.toString();
}

export async function triggerSberTestPay(paymentId: string, orderId: string): Promise<void> {
  await fetch(buildSberPayUrl(paymentId, orderId), { method: 'GET', mode: 'no-cors' });
}
